(function () {
  if (customElements.get('cart-notification')) {
    return;
  }

  const DEFAULT_DISMISS_MS = 3000;
  const VALID_STATUSES = ['success', 'error', 'info'];

  class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.timer = 0;
      this.toastEl = null;
      this.unsubscribe = null;
      this.handleNotification = this.handleNotification.bind(this);
    }

    connectedCallback() {
      if (!this.toastEl) {
        const toast = document.createElement('div');
        toast.className = 'cart-notification__toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.setAttribute('aria-atomic', 'true');
        if ('popover' in HTMLElement.prototype) {
          toast.setAttribute('popover', 'manual');
        }
        this.appendChild(toast);
        this.toastEl = toast;
      }
      if (window.themePubsub && typeof window.themePubsub.subscribe === 'function') {
        this.unsubscribe = window.themePubsub.subscribe('cart:notification', this.handleNotification);
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      window.clearTimeout(this.timer);
      this.timer = 0;
    }

    handleNotification(payload) {
      if (!payload || !payload.message) {
        return;
      }
      const toast = this.toastEl;
      if (!toast) {
        return;
      }
      const status = VALID_STATUSES.indexOf(payload.status) >= 0 ? payload.status : 'success';

      window.clearTimeout(this.timer);
      toast.classList.remove(
        'cart-notification__toast--success',
        'cart-notification__toast--error',
        'cart-notification__toast--info',
        'is-visible'
      );
      toast.textContent = payload.message;
      toast.classList.add('cart-notification__toast--' + status);
      if (typeof toast.showPopover === 'function' && !toast.matches(':popover-open')) {
        try {
          toast.showPopover();
        } catch (_) {}
      }
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
      this.timer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
        window.setTimeout(function () {
          if (typeof toast.hidePopover === 'function' && toast.matches(':popover-open')) {
            try {
              toast.hidePopover();
            } catch (_) {}
          }
        }, 220);
      }, DEFAULT_DISMISS_MS);
    }
  }

  customElements.define('cart-notification', CartNotification);
})();
